import { useState } from "react";
import { cn } from "../../lib/utils";
import { useBilling } from "./use-billing";
import { UsageLogsTab } from "./usage-logs-tab";
import { InvoicesTab } from "./invoices-tab";
import { PaymentMethodsTab } from "./payment-methods-tab";

const TABS = [
  { id: "usage", label: "Usage Logs" },
  { id: "invoices", label: "Invoices" },
  { id: "payment", label: "Payment Methods" },
] as const;
type TabId = (typeof TABS)[number]["id"];

export function BillingPage() {
  const { events, invoices, rules, saveRules } = useBilling();
  const [tab, setTab] = useState<TabId>("usage");

  return (
    <div className="space-y-4 px-4 sm:px-5 md:px-6 pb-6 pt-3 sm:pt-4">
      <div>
        <h1 className="text-sm font-semibold text-ink">Billing & Usage</h1>
        
      </div>

      {/* Underline tabs */}
      <div className="flex gap-6 border-b border-line">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={cn(
              "-mb-px border-b-2 pb-3 text-sm font-semibold transition-colors",
              tab === t.id ? "border-accent-500 text-accent-700 dark:text-accent-400" : "border-transparent text-ink-2 hover:text-ink",
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "usage" && <UsageLogsTab events={events} />}
      {tab === "invoices" && <InvoicesTab invoices={invoices} />}
      {tab === "payment" && <PaymentMethodsTab rules={rules} onSaveRules={saveRules} />}
    </div>
  );
}
